var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 633,
    height: 336,
    viewBox: "0 0 633 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_439_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505.5 69C505.5 84.7804 511.769 99.9144 522.927 111.073C534.086 122.231 549.22 128.5 565 128.5C580.78 128.5 595.914 122.231 607.073 111.073C618.231 99.9144 624.5 84.7804 624.5 69C624.5 53.2196 618.231 38.0856 607.073 26.9271C595.914 15.7687 580.78 9.5 565 9.5C549.22 9.5 534.086 15.7687 522.927 26.9271C511.769 38.0856 505.5 53.2196 505.5 69V69ZM633 69C633 87.0347 625.836 104.331 613.083 117.083C600.331 129.836 583.035 137 565 137C546.965 137 529.669 129.836 516.917 117.083C504.164 104.331 497 87.0347 497 69C497 50.9653 504.164 33.6692 516.917 20.9167C529.669 8.16427 546.965 1 565 1C583.035 1 600.331 8.16427 613.083 20.9167C625.836 33.6692 633 50.9653 633 69V69ZM543.75 35.017H570.185C584.72 35.017 593.483 43.2875 593.483 55.927C593.483 65.6 587.814 72.417 580.776 74.967L594.75 103H581.83L569.42 76.854H555.106V103H543.75V35.017ZM555.098 44.282V67.8865H568.264C576.721 67.8865 581.634 63.951 581.634 56.3265C581.634 48.566 576.569 44.282 568.57 44.282H555.098Z",
    fill: "#424242"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M431.726 0.959991V336H364.526V0.959991H431.726Z",
    fill: "#428BCA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226.372 272.16H92.9325L70.8525 336H0.29248L120.772 0.479965H199.012L319.492 336H248.452L226.372 272.16ZM208.132 218.4L159.652 78.24L111.172 218.4H208.132Z",
    fill: "#428BCA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_439_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 136,
    fill: "white",
    transform: "translate(497 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlogo);
export default __webpack_public_path__ + "static/media/iconlogo.3b42ed61956a9411eb3553f7fc221ec8.svg";
export { ForwardRef as ReactComponent };